(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictVillageBlockMappingDialogController', DistrictVillageBlockMappingDialogController);

    DistrictVillageBlockMappingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DistrictVillageBlockMapping'];

    function DistrictVillageBlockMappingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DistrictVillageBlockMapping) {
        var vm = this;

        vm.districtVillageBlockMapping = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.districtVillageBlockMapping.id !== null) {
                DistrictVillageBlockMapping.update(vm.districtVillageBlockMapping, onSaveSuccess, onSaveError);
            } else {
                DistrictVillageBlockMapping.save(vm.districtVillageBlockMapping, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:districtVillageBlockMappingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
